export const defaultRegex: { [key: string]: RegExp } = {
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    timeStamp: /\(([^()]+)\)/,
    validDecimal: /^\d+(\.\d+)?$/,
    numberFormat: /(?<=\d)(?=(\d{3})+(?!\d))/,
    website: /^(https?|ftp):\/\/([A-Za-z0-9-]+\.)+[A-Za-z]{2,}(\.[A-Za-z]{2,})?(\/[^\s]*)?$/i,
    supplierCode: /^[A-Za-z0-9\u0600-\u06FF\-\/. ]+$/
};
